import { BookingCard } from '@fjordline/styles-v3'
import styled from 'styled-components'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
`
export const MaxWidthCard = styled.div`
  > div {
    max-width: unset;
    height: 100%;
  }
`

export const AllignContentBottom = styled.div`
  > div:first-child {
    justify-content: flex-end;
    display: flex;
    -webkit-box-pack: center;
    justify-content: end;
    flex-direction: column;
    margin-top: 1rem;
  }
`

export const PlaceHolder = styled.div`
  border: 1px solid red;
  height: 4rem;
`
